import React from "react";
import { Box, IconButton } from "@mui/material";
import ArrowLeftIcon from "../../../shared/assets/icons/ArrowLeftIcon";
import { useNavigate } from "react-router-dom";

const GoBack = ({title}: any) => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <Box>
      <IconButton sx={{ padding: 0 }} onClick={goBack}>
        <ArrowLeftIcon sx={{ width: "28px", height: "28px" }} />
      </IconButton>
      <Box className="heading-2 text-center mt-6">{title}</Box>
    </Box>
  );
};
export default GoBack;